class MyAlgoSigner {
    constructor(connectedAddress, client) {
        this.connectedAddress = connectedAddress;
        this.client = client;
    }
    signBytes(bytes) {
        return this.client.signBytes(bytes, this.connectedAddress);
    }
    signLogicSig(teal) {
        return this.client.signLogicSig(teal, this.connectedAddress);
    }
    signTransaction(txs) {
        return this.client.signTransaction(txs);
    }
    tealSign(data, contractAddress) {
        return this.client.tealSign(data, contractAddress, this.connectedAddress);
    }
}

export { MyAlgoSigner };
